export default "__VITE_ASSET__DUhabtzT__"